import { render, staticRenderFns } from "./TeachGroupDetailDialog.vue?vue&type=template&id=4c60ce70&"
import script from "./TeachGroupDetailDialog.vue?vue&type=script&lang=js&"
export * from "./TeachGroupDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports